

import ImageSlider from './ImageSlider'; 


import ClassroomImage1 from '../assets/images/facilities/ClassRooms/01.jpg';
import ClassroomImage2 from '../assets/images/facilities/ClassRooms/02.jpg';
import ClassroomImage3 from '../assets/images/facilities/ClassRooms/03.jpg';
import ClassroomImage4 from '../assets/images/facilities/ClassRooms/04.jpg';
import ClassroomImage5 from '../assets/images/facilities/ClassRooms/05.jpg';

const images = [
    { src: ClassroomImage1, altText: 'Class Rooom' },
    { src: ClassroomImage2, altText: 'Class Rooom' },
    { src: ClassroomImage3, altText: 'Class Rooom' },
    { src: ClassroomImage4, altText: 'Class Rooom' },
    { src: ClassroomImage5, altText: 'Class Rooom' },
   
];
const Classrooms = () => {
    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb"> 
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                            <span className="text-warning">Classrooms</span> 
                        </h2>   
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8 order-md-first ">
                        <div className="text px-4">
                            <p>
                            The classrooms at SRN are designed to provide an engaging and effective learning environment for students. Each classroom is equipped with modern facilities to support interactive and technology-driven education.<br/><br/>

🌟 Key Features of Our Classrooms:<br/>

✅ Spacious & Well-Ventilated – Comfortable seating arrangements with proper lighting and ventilation.<br/>
✅ Smart Class Technology – Interactive whiteboards, projectors, and digital learning tools.<br/>
✅ Ergonomic Furniture – Well-designed desks and chairs for student comfort.<br/>
✅ Audio-Visual Learning Aids – Encourages visual and interactive teaching methods.<br/>
✅ Hygienic & Well-Maintained – Regular cleaning and sanitization to ensure a safe environment.<br/>
✅ Engaging Learning Atmosphere – Designed to encourage creativity, collaboration, and critical thinking.<br/><br/>

📌 Special Classroom Facilities:<br/>

🔹 Digital Classrooms – Smartboards and multimedia content for an interactive learning experience.<br/>
🔹 Subject-Specific Classrooms – Special rooms for science, mathematics, and language studies.<br/>
🔹 Group Learning Spaces – Encourages teamwork, discussions, and project-based learning.<br/>
🔹 Teacher-Student Engagement – Personalized learning with close guidance from teachers.<br/><br/>

📢 Classroom Guidelines:<br/>

📍 Maintain discipline and respect fellow students and teachers.<br/>
📍 Keep the classroom clean and organized.<br/>
📍 Participate actively in class discussions and activities.<br/>
📍 Follow school rules and respect learning resources.<br/>

The classrooms at SRN are more than just spaces for instruction—they are centers of creativity, collaboration, and intellectual growth, preparing students for academic and personal success.    </p>
                        </div>
                    </div>
                    <div className=" col-md-4 order-md-first wrap-about">
                    <ImageSlider images={images} />              
                    </div>
                </div>  
            </div>
            <hr className="custom-hr"/>
        </section>
    );
};

export default Classrooms;
